import React, { useEffect, useRef, useState } from 'react';
import { Quote } from 'lucide-react';
import { FEATURED_TESTIMONIAL } from '../data/mock';
import { Reveal } from './effects';

const FeaturedTestimonial = () => {
  const t = FEATURED_TESTIMONIAL;
  const ref = useRef(null);
  const [seen, setSeen] = useState(false);
  const words = t.quote.split(' ');

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setSeen(true);
          obs.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      className="relative py-32 lg:py-52 bg-[#F5F3EF] overflow-hidden"
    >
      <div className="absolute top-[8%] left-[3%] opacity-[0.05] pointer-events-none">
        <Quote
          size={520}
          className="text-[#9A7F4F]"
          strokeWidth={0.4}
          style={{
            transform: seen ? 'rotate(0deg) scale(1)' : 'rotate(-6deg) scale(0.9)',
            opacity: seen ? 1 : 0,
            transition: 'transform 1400ms cubic-bezier(0.22,1,0.36,1), opacity 1400ms ease-out',
          }}
        />
      </div>

      <div className="relative container-x text-center max-w-[920px] mx-auto">
        <Reveal>
          <div className="inline-flex items-center justify-center gap-3 mb-10">
            <span className="h-px w-12 bg-[#9A7F4F]" />
            <span
              className="text-[10.5px] tracking-[0.35em] uppercase text-[#9A7F4F] font-medium"
              style={{ fontFamily: '"JetBrains Mono", monospace' }}
            >
              Müşteri Sözü
            </span>
            <span className="h-px w-12 bg-[#9A7F4F]" />
          </div>
        </Reveal>

        <blockquote
          className="font-display italic text-[#1A1A1A] mx-auto"
          style={{
            fontSize: 'clamp(20px, 2.4vw, 32px)',
            lineHeight: 1.42,
            letterSpacing: '-0.008em',
            fontWeight: 300,
            maxWidth: '820px',
            fontVariationSettings: '"opsz" 36, "SOFT" 30',
          }}
        >
          <span className="text-[#9A7F4F] not-italic font-medium mr-1.5">"</span>
          {words.map((w, i) => (
            <span
              key={i}
              className="inline-block"
              style={{
                opacity: seen ? 1 : 0,
                transform: seen ? 'translateY(0)' : 'translateY(12px)',
                transition: `opacity 700ms cubic-bezier(0.22,1,0.36,1) ${250 + i * 35}ms, transform 700ms cubic-bezier(0.22,1,0.36,1) ${250 + i * 35}ms`,
              }}
            >
              {w}
              {i < words.length - 1 && '\u00A0'}
            </span>
          ))}
          <span className="text-[#9A7F4F] not-italic font-medium ml-1">"</span>
        </blockquote>

        <Reveal delay={300 + words.length * 35}>
          <div className="mt-12 lg:mt-14 flex items-center justify-center gap-5">
            <div
              className="h-12 w-12 rounded-full bg-[#72272D] grid place-items-center text-[#C9A875] border border-[#9A7F4F]/35 text-[13px] font-medium tracking-wider"
              style={{ fontFamily: '"JetBrains Mono", monospace' }}
            >
              {t.name
                .split(' ')
                .map((n) => n[0])
                .join('')
                .replace(/\./g, '')
                .slice(0, 2)}
            </div>
            <div className="text-left">
              <div className="text-[#1A1A1A] font-medium text-[14px]">{t.name}</div>
              <div className="text-[#1A1A1A]/60 text-[12px] mt-0.5 leading-snug">
                {t.title} · {t.company}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FeaturedTestimonial;
